import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-description-expand',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './description-expand.component.html',
  styleUrl: './description-expand.component.scss'
})
export class DescriptionExpandComponent {
  @Input() public content: ViewerContent;
  header: string = '';
  canShowCopyButton: boolean = false;
  canShowSaveButton: boolean = false;
  description: string = '';
  hasMaxLengthRestrictionForDescription: boolean = false;
  descriptionMaxLength: number = -1;

  constructor(public ngModal: NgbActiveModal) {}

  ngOnInit() {
    if (this.content) {
      this.description = this.content.data ?? '';
      this.header = this.content.header ?? '';
      this.canShowCopyButton = this.content.canShowCopyButton;
      this.canShowSaveButton = this.content.canShowSaveButton;
      this.hasMaxLengthRestrictionForDescription = this.content.hasMaxLengthRestrictionForDescription ?? false;
      if (this.content.hasMaxLengthRestrictionForDescription) {
        this.descriptionMaxLength = this.content.descriptionMaxLength ?? -1;
      }
    }
  }

  closePopup() {
    this.ngModal.dismiss();
  }

  copyToClipboard() {
    navigator.clipboard.writeText(this.description ?? "");
  }
  
}

export type ViewerContent = {
  data: string | null;
  header: string | null;
  canShowCopyButton: boolean;
  canShowSaveButton: boolean;
  hasMaxLengthRestrictionForDescription?: boolean;
  descriptionMaxLength?: number;
};